export const CONFIRM_ACTION = {
  icon: 'mdi-check-circle-outline',
  color: '#2E7D32',
  event: 'confirm',
  permissionTypes: ['UPDATE']
};

export const DETAILS_ACTION = { icon: 'mdi-account-box', event: 'details', permissionTypes: ['GET'] };

export const DELETE_ACTION = {
  icon: 'mdi-trash-can-outline',
  event: 'delete',
  permissionTypes: ['DELETE'],
  color: 'red',
  tooltipText: 'Usuń'
};

export const EDIT_ACTION = {
  icon: 'mdi-pencil-outline',
  event: 'edit',
  permissionTypes: ['UPDATE'],
  color: '#d4b004',
  tooltipText: 'Edytuj'
};

export const ROLES_ACTION = {
  icon: 'mdi-sitemap',
  event: 'roles',
  permissions: ['USER.ROLE_MANAGE']
};
